/* unplugin-vue-components disabled */import { render } from "./upload.vue?vue&type=template&id=30fbea4a&scoped=true"
import script from "./upload.vue?vue&type=script&lang=js"
export * from "./upload.vue?vue&type=script&lang=js"

import "./upload.vue?vue&type=style&index=0&id=30fbea4a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30fbea4a"],['__file',"src/components/chat-input/upload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30fbea4a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30fbea4a', __exports__)) {
    api.reload('30fbea4a', __exports__)
  }
  
  module.hot.accept("./upload.vue?vue&type=template&id=30fbea4a&scoped=true", () => {
    api.rerender('30fbea4a', render)
  })

}


export default __exports__